export default __webpack_public_path__ + "static/media/language.fefeec8f.svg";